import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IntelligenceDiagram } from './IntelligenceDiagram';
import { easeOutStrong } from '../../utils/motion';
export function HomeHero() {
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-28" data-id="element-1108" data-mp="2470qg9yj0rdv">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center" data-id="element-1109" data-mp="295c12mwnb5x5">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="lg:col-span-7" data-id="element-1110" data-mp="2wuwtrxilphjm">
          <h1 className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-ink-dark leading-[1.03] tracking-tight" data-id="element-1111" data-mp="2n2hej7yov72f">
            Connected knowledge. Capable people. Coordinated action.
          </h1>
          <p className="mt-8 text-xl lg:text-2xl text-ink-dark/80 leading-relaxed max-w-2xl" data-id="element-1112" data-mp="3kjpndnbr3db2">
            SyNeural connects knowledge, people and institutional workflows. Through Noetivra, organizations can bring
            information together, coordinate services and turn insight into practical action—with dedicated workspaces
            for government, research, education, workforce development and clinical work.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row sm:items-center gap-6" data-id="element-1113" data-mp="svrheu5iv1qw">
            <a href="/solutions" className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 shadow-sm whitespace-nowrap" data-id="element-1114" data-mp="17kxgmi4d0rys">
              Find your solution
              <ArrowRight size={18} aria-hidden="true" data-id="element-1115" data-mp="1ckjtgqga0672" />
            </a>
            <a href="/how-it-works" className="inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1116" data-mp="3idryigofulfb">
              See how it works
              <ArrowRight size={16} aria-hidden="true" data-id="element-1117" data-mp="1hcu0w800zb50" />
            </a>
          </div>
          <p className="mt-8 text-sm text-ink-muted" data-id="element-1118" data-mp="1mboi55icgrn0">Interactive demos available. Production platform under development.</p>
        </motion.div>

        <div className="lg:col-span-5" data-id="element-1119" data-mp="1rbt255igo4hz">
          <IntelligenceDiagram data-id="element-1120" data-mp="1w9cgs6j2mjag" />
        </div>
      </div>
    </section>;
}